export default __webpack_public_path__ + "static/media/kaus-wireframes-color.59ef186d.jpg";